// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1Xnj0","cell":"ColumnAccessor_cell__2ep3d","firstCellAccent":"ColumnAccessor_firstCellAccent__1-Dok"};